import * as PropTypes from 'prop-types'

/** Includes all standard PropTypes + our custom ones. */
const AllPropTypes = Object.assign({}, PropTypes)
export default AllPropTypes

const createElementOf = (elementCheck, isRequired) => elementName => {
	const func = (props, name, component, ...rest) => {
		const elementError = elementCheck(props, name, component, ...rest)
		if (elementError) {
			return elementError
		}
		if (props[name] && props[name].type.name != elementName) {
			const type = typeof props[name].type == 'object'? props[name].type.name : props[name].type
			return new Error(`Invalid \`${name}\` instance of <${type}> supplied for \`${component}\`, expected \`${elementName}\`.`)
		}
	}
	if (!isRequired) {
		func.isRequired = createElementOf(PropTypes.element.isRequired, true)(elementName)
	}
	return func
}

/**
 * Requires the given prop to be a React element (same as PropTypes.element) of a given instance.
 * For this to work, you need to always name your function components, don't use anonymous/arrow functions.
 *
 * @example ```
 * MainComponent.Sub = function MainComponentSub(...props) { [...] }
 * ```
 * @type {function(string)}
 */
AllPropTypes.elementOf = createElementOf(PropTypes.element, false)

